import { Component, Inject, OnInit, TemplateRef } from '@angular/core';
import { DeviceService } from '@services/device.service';
import { UserService } from '@services/user.service';
import { AppComponent } from 'app/app.component';
import { Authorization } from 'app/shared/classes/authorization';
import { CommonShared } from 'app/shared/classes/common';
import moment from 'moment';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { ConfirmationService } from 'primeng/api';
import { KigSettings, KIG_SETTINGS } from 'settings/kig-settings';
import {EMPTY, from, Observable} from 'rxjs';
import { ChangeLogNotesParams, ChangeLogNotesComponent } from 'app/components/messages/changelog-notes/changelognotes.components';
import { Device, UserGroup, Task, DeviceMessageInfo } from '@models';
import { CloudFileStorage } from '@models/Device/CloudFileStorage.model';
import { FileStorageService } from '@services/fileStorage.service';
import { IrrigationStatsCriteria } from '@models/Device/IrrigationStatsCriteria.model';
import { DateRanges } from '@models/ranges';
import { IrrigationStats } from '@models/Device/IrrigationStats.model';

interface DateRange {
  startDate: moment.Moment;
  endDate: moment.Moment;
}

export interface IrrigationStatsParams {
  devices: Device[];
}

@Component({
  standalone: false,
  selector: 'app-irrigation-stats',
  templateUrl: './irrigation-stats.component.html',
  styleUrls: ['./irrigation-stats.component.scss']
})

export class IrrigationStatsModalComponent implements OnInit, IrrigationStatsParams {

  auth = new Authorization();
  common = new CommonShared();

  modalDragOn: boolean = false;
  devices: Device[] = [];
  irrigationStats: IrrigationStats[] = [];
  awaitIrrigationStats: boolean = false;

  selectedDateRange: DateRange = { startDate: moment().startOf('day'), endDate: moment().endOf('day') };
  ranges = DateRanges;
  public invalidDates: moment.Moment[] = [];
  
  public irrigationStatsCols = [
    {field: 'device.name', header: 'Controller Name', width: '37%'},
    {field: 'zoneStats.zone', header: 'Zone#', width: '7%'},
    {field: 'zoneStats.irrigationCount', header: 'Count', width: '7%'},
    {field: 'zoneStats.irrigationTimeHours', header: '#Hrs', width: '7%'},
    {field: 'zoneStats.waterConsumption', header: 'Water', width: '7%'},
    {field: 'ZoneStats.utilization', header: 'Util%', width: '7%'},
    {field: 'totalCount', header: 'Total(Cnt)', width: '7%'},
    {field: 'totalTime', header: 'Total(Hrs)', width: '7%'},
    {field: 'totalConsumption', header: 'Total(Water)', width: '7%'},
    {field: 'totalUtilization', header: 'Total(Util)', width: '7%'}
  ];


  constructor(public bsModalRef: BsModalRef, private toastr: ToastrService, private modalService: BsModalService, public _fileStorageService: FileStorageService,
    private deviceService: DeviceService, public global: AppComponent, private confirmationService: ConfirmationService,
    @Inject(KIG_SETTINGS) private settings: KigSettings, public _userService: UserService) {
  }


  ngOnInit(): void {
  }


  setDragOn(drag: boolean) {
    this.modalDragOn = drag;

    if (drag) {
      setTimeout(() => {
        this.modalDragOn = false;
      },3000);
    }
  }


  getIrrigationStats() {
    this.awaitIrrigationStats = true;

    var criteria: IrrigationStatsCriteria = {
      startDate: this.selectedDateRange.startDate.local().toDate(),
      endDate: this.selectedDateRange.endDate.local().toDate(),
      deviceIds: this.devices.map(d => d.id)
    }

    this.deviceService.getIrrigationStats(criteria).subscribe(
      results => {
        this.irrigationStats = results;
        
        this.irrigationStats.forEach(x => {
          x.totalCount = x.zoneStats.reduce((sum, zone) => sum + zone.irrigationCount, 0);
          x.totalTime = x.zoneStats.reduce((sum, zone) => sum + zone.irrigationTimeHours, 0);
          x.totalTime = Math.round(x.totalTime * 1000) / 1000; 
          x.totalConsumption = x.zoneStats.reduce((sum, zone) => sum + zone.waterConsumption, 0);
        });

        this.awaitIrrigationStats = false;
      },
      err => {
        this.toastr.error("Error retrieving irrigation stats");
        this.awaitIrrigationStats = false;
      });
  }


  isInvalidDate = (m: moment.Moment) => this.invalidDates.some(d => d.isSame(m, 'day'));

  datesUpdated(quickPick: string): void {
    if (quickPick === 'Last 4 hrs') {
      this.selectedDateRange = { startDate: moment().add(-4 , 'hours'), endDate: moment() };
    }
    else if (quickPick === 'Last 8 hrs') {
      this.selectedDateRange = { startDate: moment().add(-8 , 'hours'), endDate: moment() };
    }
    else if (quickPick === 'Last 12 hrs') {
      this.selectedDateRange = { startDate: moment().add(-12 , 'hours'), endDate: moment() };
    }
    else if (quickPick === 'Last 24 hrs') {
      this.selectedDateRange = { startDate: moment().add(-24 , 'hours'), endDate: moment() };
    }

    this.getIrrigationStats();
  }


  toggleIrrigationStatRow(irrigationStat: IrrigationStats) {
    irrigationStat.expanded = !irrigationStat.expanded;
  }


}
